import styled from "@emotion/styled";
import { Button } from "@gumtree/ui-library";
import {
    colorVariables,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    boxSizes,
    lineHeights,
    mediaQuery,
    breakpoints,
} from "@gumtree/ui-library/src/base/theme";

export const EditButton = styled(Button)`
    font-weight: ${fontWeights.bold};
    color: ${colors.blade};
    font-size: ${fontSizes.base};
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0px;
`;

export const SellerBuyBlockContainer = styled.div<{ isMobileCardsLayout: boolean }>`
    padding: ${gutterSizes.large} ${gutterSizes.large} 0px ${gutterSizes.large};
    ${({ isMobileCardsLayout }) =>
        isMobileCardsLayout &&
        `
        width: 100%;
        padding: ${gutterSizes.medium} 0px 0px 0px;
  `}
`;

export const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-bottom: ${gutterSizes.large};
    ${mediaQuery.until(breakpoints.medium)} {
        gap: ${gutterSizes.xsmall};
        margin-bottom: ${gutterSizes.medium};
    }
`;

export const ItemPrice = styled.h2`
    font-weight: ${fontWeights.bold};
    font-size: ${fontSizes.pgLarge};
    line-height: ${lineHeights.large};
    color: ${colorVariables.textPrimary};
    margin: 0px;
    ${mediaQuery.until(breakpoints.medium)} {
        font-weight: ${fontWeights.bolder};
        font-size: ${fontSizes.xlarge};
        line-height: ${lineHeights.large};
        color: ${colors.green} !important;
    }
`;

export const ExtraPrice = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${gutterSizes.base};
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    color: ${colorVariables.textPrimary};
`;

export const PriceDivider = styled.span`
    font-weight: ${fontWeights.normal};
    font-size: ${fontSizes.base};
    line-height: 24px;
    color: ${colorVariables.borderMedium};
`;

export const BuyButtonContainer = styled.div`
    padding-bottom: ${gutterSizes.large};
    border-bottom: 1px solid ${colorVariables.borderLight};

    ${mediaQuery.until(breakpoints.medium)} {
        border-bottom: none;
    }
`;

export const StyledButton = styled(Button)<{ isStickyHeader?: boolean }>`
    height: 44px;
    width: 100%;
    margin-left: 0px !important;
    border-radius: ${({ isStickyHeader }) =>
        isStickyHeader ? boxSizes.borderRadius : boxSizes.borderRadius4};
    justify-content: center;
    font-weight: ${fontWeights.bold};
`;
